import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import { IAuth, useAuth } from '../context/auth';
import { routing } from './constans';

const Routes: React.FC = () => {
  function RouteWithSubRoutes(route: any) {
    const { claims, user, isAdmin }: IAuth = useAuth();

    //нужно проверить есть ли совпадения в двух массивах
    //claims = доступные
    //route.claims = разрешенные
    let guardBoard = false;
    for (let item of route.claims) {
      claims!.indexOf(item) >= 0 ? (guardBoard = true) : (guardBoard = false);
      if (item === 'admin' && isAdmin) {
        guardBoard = true;
      }
    }

    return (
      <Route
        path={route.path}
        exact={route.exact}
        render={(props) => {
          const defaultPage = user?.defaultPage || '/notFound';
          //return  <route.component {...props} routes={route.routes} />
          if (guardBoard || route.claims.indexOf('all') >= 0) {
            return <route.component {...props} routes={route.routes} />;
          } else {
            return <Redirect to={defaultPage} />;
          }
        }}
      />
    );
  }

  return (
    <Switch>
      {routing.map((route, i) => (
        <RouteWithSubRoutes key={i} {...route} />
      ))}
    </Switch>
  );
};

export default Routes;
